export {
  required,
  email,
  sameAs,
  minLength,
  maxLength,
  minValue,
  maxValue,
  alphaNum,
  requiredIf,
} from 'vuelidate/lib/validators';

export const onlyCharOrNumber = (value: string): boolean => {
  const regex = /^[A-Za-z0-9]*$/;
  return regex.test(value);
};

export const onlyNumber = (value: string): boolean => {
  const regex = /^\d*$/;
  return regex.test(value);
};

export const notNumber = (value: string): boolean => {
  const regex = /^\D*$/;
  return regex.test(value);
};

export const alphaNumSpace = (value: string): boolean => {
  const regex = /^[\w\-\s]+$/;
  return regex.test(value);
};

export const alphaNumSpaceOrEmpty = (value: string): boolean => {
  const regex = /^$|^[\w\-\s]+$/;
  return regex.test(value);
};

// Allows all unicode letters (but requires at least one),
// plus hyphens/dashes, spaces, all apostrophe variants, and full stops.
export const name = (value: string): boolean => {
  const regex = /^(?=.*\p{L})[\p{L}\p{M}\p{Pd}\u2212\s'\u2018\u2019\u02BC\u2032\uFF07`\u00B4.]+$/u;
  return regex.test(value);
};

export const isOptional = (callback: (arg0: string) => void, value: string): void | boolean => {
  if (value.length && typeof callback === 'function') {
    return callback.call(this, value);
  }
  return true;
};

export const noSpacesOrSpecialCharacters = (value: string): boolean => {
  const regex = /^[a-zA-Z0-9]+$/;
  return regex.test(value);
};

export const postalAreaCode = (value: string): boolean => {
  const regex = /^[A-Za-z]{1,2}[0-9][0-9A-Za-z]?$/;
  return regex.test(value.trim());
};
